var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* tslint:disable: class-name */
/*
 * AUTOGENERATED FILE - DO NOT EDIT
 */
import { ewJSONContract } from './ewJSONContract';
import { JSONStruct, array_property, nullable, property } from 'badphraim/data/JSONStruct';
export class ewExerciseProfileJson extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.avtaler = [];
        /** @override */ this.created = 0;
        /** @override */ this.eier = 0;
        /** @override */ this.hascard = false;
        /** @override */ this.id = 0;
        /** @override */ this.is_sponsored = false;
        /** @override */ this.isactive = false;
        /** @override */ this.seen_privacy_statement = false;
        /** @override */ this.signed_privacy_statement = false;
    }
}
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "access", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "adresse", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "ansattnr", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "avdeling", void 0);
__decorate([
    array_property(ewJSONContract),
    __metadata("design:type", Array)
], ewExerciseProfileJson.prototype, "avtaler", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "birth", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewExerciseProfileJson.prototype, "contract_id", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewExerciseProfileJson.prototype, "created", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewExerciseProfileJson.prototype, "eier", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "epost", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "etternavn", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewExerciseProfileJson.prototype, "fodttimestamp", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "fornavn", void 0);
__decorate([
    property,
    __metadata("design:type", Boolean)
], ewExerciseProfileJson.prototype, "hascard", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewExerciseProfileJson.prototype, "id", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "imageURL", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "info", void 0);
__decorate([
    property,
    __metadata("design:type", Boolean)
], ewExerciseProfileJson.prototype, "is_sponsored", void 0);
__decorate([
    property,
    __metadata("design:type", Boolean)
], ewExerciseProfileJson.prototype, "isactive", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewExerciseProfileJson.prototype, "kjonn", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewExerciseProfileJson.prototype, "klipp", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewExerciseProfileJson.prototype, "mail_ok", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewExerciseProfileJson.prototype, "memberid", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "mobil", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "personnr", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "postnr", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "poststed", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "rolle", void 0);
__decorate([
    property,
    __metadata("design:type", Boolean)
], ewExerciseProfileJson.prototype, "seen_privacy_statement", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewExerciseProfileJson.prototype, "seen_privacy_statement_time", void 0);
__decorate([
    property,
    __metadata("design:type", Boolean)
], ewExerciseProfileJson.prototype, "signed_privacy_statement", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewExerciseProfileJson.prototype, "sms_ok", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "telefax", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewExerciseProfileJson.prototype, "telefon", void 0);
